import { useTranslation } from "react-i18next";
import { useSetRecoilState } from "recoil";
import { navigationPromptState, alertState } from "src/recoil/atoms/global";
import { useMutation } from "src/Hooks/useReactQuery";
import { editTestPackage } from "src/services/test-packages";
import { usePatchedNavigate } from "src/Hooks/usePatchedNavigate";

const useUpdateTestPackage = (options) => {
  const { t } = useTranslation("test-package");
  const navigate = usePatchedNavigate();
  const showAlert = useSetRecoilState(alertState);
  const navigationPrompt = useSetRecoilState(navigationPromptState);

  const updateTestPackageMutation = useMutation({
    mutationFn: ({ data }) => editTestPackage({ data }),
    onSuccess: () => {
      showAlert({
        status: true,
        message: t("detail.edit_success"),
        type: "success",
      });
      navigationPrompt(false);
      if (options?.redirectOnSuccess) {
        setTimeout(() => {
          navigate(options.redirectOnSuccess);
        }, 500);
      }
    },
    onError: (err) => {
      showAlert({
        status: true,
        message: err?.response?.data?.error?.detail || err?.response?.data?.error?.message || t("detail.edit_failed"),
        type: "danger",
      });
    },
  });

  const submitData = ({ data }) => {
    updateTestPackageMutation.mutate({ data });
  };

  return {
    updateTestPackageMutation,
    submitData,
    isLoading: updateTestPackageMutation.isLoading,
    isError: updateTestPackageMutation.isError,
    error: updateTestPackageMutation.error,
  };
};

export default useUpdateTestPackage;
